//(function () {
//    'use strict';

//    angular.module("imApp").factory("collectionsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
